import React from 'react';
import { Link } from 'react-router-dom';
import { User as UserIcon, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const TopNav: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  
  // Function to get display name without making API calls
  const getDisplayName = (): string => {
    if (!user) return "User";
    
    // Check if username is provided and it's not the same as email
    if (user.username && user.email && user.username !== user.email) {
      return user.username;
    }
    
    // If username equals email or only email is available, use part before @
    if (user.email) {
      return user.email.split('@')[0];
    }
    
    // Default fallback
    return "User";
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header className="fixed top-0 right-0 z-40 p-4 hidden md:block">
      <div className="flex justify-end">
        {isAuthenticated ? (
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 transition-colors">
              <Avatar className="h-8 w-8">
                <AvatarFallback>
                  <UserIcon className="h-4 w-4" />
                </AvatarFallback>
              </Avatar>
              <span className="font-medium">{getDisplayName()}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <DropdownMenuItem className="cursor-pointer" asChild>
                <Link to="/profile">
                  <UserIcon className="mr-2 h-4 w-4" />
                  <span>Profile</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem className="cursor-pointer text-red-600" onClick={handleLogout}>
                <LogOut className="mr-2 h-4 w-4" />
                <span>Logout</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <Link to="/signin">
            <Button 
              variant="outline" 
              className="bg-yellow-400 text-white hover:bg-yellow-400/90 font-bold"
            >
              Log in
            </Button>
          </Link>
        )}
      </div>
    </header>
  );
};

export default TopNav; 